/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierAccountOption
 */
export interface CarrierAccountOption {
  /**
   *
   * @type {string}
   * @memberof CarrierAccountOption
   */
  accountNumber: string;
  /**
   *
   * @type {string}
   * @memberof CarrierAccountOption
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierAccountOption
   */
  isCustomerSpecific: boolean;
}

/**
 * Check if a given object implements the CarrierAccountOption interface.
 */
export function instanceOfCarrierAccountOption(
  value: object,
): value is CarrierAccountOption {
  if (!("accountNumber" in value) || value["accountNumber"] === undefined)
    return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  if (
    !("isCustomerSpecific" in value) ||
    value["isCustomerSpecific"] === undefined
  )
    return false;
  return true;
}

export function CarrierAccountOptionFromJSON(json: any): CarrierAccountOption {
  return CarrierAccountOptionFromJSONTyped(json, false);
}

export function CarrierAccountOptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierAccountOption {
  if (json == null) {
    return json;
  }
  return {
    accountNumber: json["accountNumber"],
    description: json["description"],
    isCustomerSpecific: json["isCustomerSpecific"],
  };
}

export function CarrierAccountOptionToJSON(json: any): CarrierAccountOption {
  return CarrierAccountOptionToJSONTyped(json, false);
}

export function CarrierAccountOptionToJSONTyped(
  value?: CarrierAccountOption | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    accountNumber: value["accountNumber"],
    description: value["description"],
    isCustomerSpecific: value["isCustomerSpecific"],
  };
}
